import * as Yup from 'yup';

import { startOfDay, add, format } from 'date-fns';

const today = startOfDay(new Date(Date.now()));
const yearAfter = add(today, { years: 1 });

export const validationSchema = Yup.object({
  id: Yup.string().required(),
  groupName: Yup.string().required('Required'),
  rawText: Yup.string().required(),
  locale: Yup.string().required(),
  liveDate: Yup.date()
    .min(today, `Cannot be past ${format(today, 'dd.MM.yyyy')}`)
    .max(yearAfter, `Cannot be after ${format(yearAfter, 'dd.MM.yyyy')}`)
    .required('Required'),
});
